(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function readVariants(wrapper) {
    var script = wrapper.querySelector('script[data-cl-lens-variants]');
    if (!script) return [];
    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  function getCurrentVariantId(wrapper, form) {
    if (form && form.elements && form.elements.id && form.elements.id.value) {
      var fromForm = parseInt(form.elements.id.value, 10);
      if (!isNaN(fromForm)) return fromForm;
    }
    var fromAttr = parseInt(wrapper.getAttribute('data-cl-lens-current-variant-id'), 10);
    if (!isNaN(fromAttr)) return fromAttr;
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    return urlVariant ? parseInt(urlVariant, 10) : null;
  }

  function findVariantByOption(variants, position, newName, currentVariantId) {
    var pos = parseInt(position, 10);
    var optionKey = 'option' + pos;
    var current = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === currentVariantId) {
        current = variants[i];
        break;
      }
    }
    if (!current) current = variants[0];
    if (!current) return null;

    var fallback = null;
    for (var j = 0; j < variants.length; j++) {
      var v = variants[j];
      if (v[optionKey] !== newName) continue;
      var otherOptionsMatch = true;
      for (var p = 1; p <= 3; p++) {
        if (p === pos) continue;
        var k = 'option' + p;
        if ((current[k] || null) !== (v[k] || null)) {
          otherOptionsMatch = false;
          break;
        }
      }
      if (otherOptionsMatch) {
        if (v.available !== false) return v;
        if (!fallback) fallback = v;
      }
    }
    if (fallback) return fallback;

    for (var m = 0; m < variants.length; m++) {
      if (variants[m][optionKey] === newName) return variants[m];
    }
    return null;
  }

  function wireLensModal(wrapper) {
    var trigger = wrapper.querySelector('[data-cl-lens-modal-open]');
    if (!trigger) return;

    var modalId = trigger.getAttribute('aria-controls') || '';
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    // Portal the modal to <body> so it escapes ancestor stacking contexts
    // (e.g. `.product-info` with z-index: 2, or sticky header transforms).
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    // DEFENSIVE: if `snippets/buy-buttons.liquid` ignored the `form_id`
    // parameter and rendered the modal's form with the same id as the main
    // product form, dedupe at runtime. Two forms sharing an id break Easify
    // because property inputs use `form="..."` to bind by id, and
    // document.getElementById only returns the first match.
    (function dedupeModalFormId() {
      var modalForm = modal.querySelector('form.shopify-product-form');
      if (!modalForm || !modalForm.id) return;
      var collisions = document.querySelectorAll('form#' + CSS.escape(modalForm.id));
      if (collisions.length <= 1) return;

      var sectionId = wrapper.getAttribute('data-cl-lens-section-id') || 'modal';
      var newId = 'product-form-lens-modal-' + sectionId;
      var oldId = modalForm.id;
      modalForm.id = newId;

      modal.querySelectorAll('[form="' + oldId + '"]').forEach(function (el) {
        el.setAttribute('form', newId);
      });
      var buyButtons = modal.querySelector('buy-buttons[form="' + oldId + '"]');
      if (buyButtons) buyButtons.setAttribute('form', newId);
    })();

    wireOptionRevealScroll(modal);

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      // Force a reflow so the transition runs on the very next frame.
      // eslint-disable-next-line no-unused-expressions
      modal.offsetWidth;
      modal.classList.add('is-open');
      document.documentElement.classList.add('cl-lens-modal-open');
      document.body.classList.add('cl-lens-modal-open');
      history.pushState({ clLensModal: modalId }, '');
      var firstFocusable = modal.querySelector('.cl-lens-modal__close');
      if (firstFocusable) firstFocusable.focus();
    }

    function close(skipHistory) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cl-lens-modal-open');
      document.body.classList.remove('cl-lens-modal-open');

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }

      if (!skipHistory) {
        history.back();
      }
    }

    trigger.addEventListener('click', open);

    modal.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-cl-lens-modal-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });

    window.addEventListener('popstate', function () {
      if (modal.classList.contains('is-open')) {
        close(true);
      }
    });
  }

  /* Auto-scroll the modal panel when Easify's conditional logic reveals new
     option groups (or when a newly-required group sits below the fold).
     Without this, newly-shown options below the fold are easy to miss after
     the user picks Lens Type / Thickness / Lens. */
  function wireOptionRevealScroll(modal) {
    var easifyContainer = modal.querySelector('.easify-product-options');
    if (!easifyContainer) return;

    var visibility = new WeakMap();
    var ready = false;

    function isVisible(el) { return !el.classList.contains('tpo_hidden'); }

    function snapshotAll() {
      easifyContainer.querySelectorAll('.tpo_option-container').forEach(function (el) {
        visibility.set(el, isVisible(el));
      });
    }

    function arm() {
      snapshotAll();
      /* Re-snapshot after a short delay so any initial Easify conditional-
         logic pass is treated as the baseline, not a user-triggered reveal. */
      setTimeout(function () {
        snapshotAll();
        ready = true;
      }, 400);
    }

    if (easifyContainer.querySelector('.tpo_option-container')) {
      arm();
    } else {
      var initObserver = new MutationObserver(function () {
        if (easifyContainer.querySelector('.tpo_option-container')) {
          initObserver.disconnect();
          arm();
        }
      });
      initObserver.observe(easifyContainer, { childList: true, subtree: true });
    }

    function findScrollParent(start) {
      var el = start.parentElement;
      while (el) {
        var style = window.getComputedStyle(el);
        var oy = style.overflowY;
        if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && el.scrollHeight > el.clientHeight + 1) {
          return el;
        }
        if (el === modal) break;
        el = el.parentElement;
      }
      return modal.querySelector('.cl-lens-modal__panel') || modal;
    }

    function scrollTargetIntoView(target) {
      var scrollContainer = findScrollParent(target);
      var elRect = target.getBoundingClientRect();
      var containerRect = scrollContainer.getBoundingClientRect();
      var offset = scrollContainer.scrollTop + (elRect.top - containerRect.top) - 16;
      if (offset < 0) offset = 0;
      if (typeof scrollContainer.scrollTo === 'function') {
        scrollContainer.scrollTo({ top: offset, behavior: 'smooth' });
      } else {
        scrollContainer.scrollTop = offset;
      }
    }

    var classObserver = new MutationObserver(function (mutations) {
      if (!ready) {
        mutations.forEach(function (m) {
          if (m.target && m.target.classList && m.target.classList.contains('tpo_option-container')) {
            visibility.set(m.target, isVisible(m.target));
          }
        });
        return;
      }

      var topMost = null;
      var topMostY = Infinity;
      mutations.forEach(function (m) {
        var el = m.target;
        if (!el || !el.classList || !el.classList.contains('tpo_option-container')) return;
        var nowVisible = isVisible(el);
        var prev = visibility.has(el) ? visibility.get(el) : nowVisible;
        visibility.set(el, nowVisible);
        if (nowVisible && prev === false) {
          var y = el.getBoundingClientRect().top;
          if (y < topMostY) {
            topMostY = y;
            topMost = el;
          }
        }
      });

      if (topMost) {
        var target = topMost;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { scrollTargetIntoView(target); });
        });
      }
    });

    classObserver.observe(easifyContainer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  function resolveProductHandle(wrapper) {
    var attr = wrapper.getAttribute('data-cl-lens-product-handle');
    // Reject empty / Liquid-rendered-an-object (e.g. "[object Object]") values.
    if (attr && attr.indexOf('[object') === -1) return attr;
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function wireLensModule(wrapper) {
    if (wrapper.dataset.clLensWired === '1') return;
    wrapper.dataset.clLensWired = '1';

    wireLensModal(wrapper);

    var select = wrapper.querySelector('[data-cl-lens-select]');
    var optionPosition = wrapper.getAttribute('data-cl-lens-option-position');
    var productHandle = resolveProductHandle(wrapper);
    var sectionId = wrapper.getAttribute('data-cl-lens-section-id');
    var rerender = wrapper.closest('product-rerender');
    if (!select || !optionPosition || !productHandle || !sectionId || !rerender) {
      if (window.console && !productHandle) {
        console.warn('[lens-module] missing product handle — aborting wire-up');
      }
      return;
    }

    var variants = readVariants(wrapper);
    if (!variants.length) return;

    var observeFormId = rerender.getAttribute('observe-form');
    var form = (observeFormId && document.forms[observeFormId]) || rerender.querySelector('form');
    if (!form) return;

    function updateSize() {
      var selected = select.options[select.selectedIndex];
      if (!selected) return;
      var newName = selected.getAttribute('data-option-name') || selected.textContent.trim();
      var currentVariantId = getCurrentVariantId(wrapper, form);
      var newVariant = findVariantByOption(variants, optionPosition, newName, currentVariantId);
      if (!newVariant) return;

      var url = ROOT + 'products/' + productHandle + '?variant=' + newVariant.id + '&section_id=' + sectionId;

      return fetch(url)
        .then(function (response) { if (!response.ok) throw Error('Size unavailable'); return response.text(); })
        .then(function (html) {
          var newContent = document.createRange().createContextualFragment(html);

          if (form.elements && form.elements.id) {
            form.elements.id.value = newVariant.id;
            form.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // Modal lives in <body> after portal, so its form is outside
          // <product-rerender> — the update above doesn't reach it. Sync the
          // modal form's variant id input directly so its ATC submits the
          // correct variant.
          var modal = document.getElementById('cl-lens-modal-' + sectionId);
          if (modal) {
            var modalForm = modal.querySelector('form.shopify-product-form');
            if (modalForm && modalForm.elements && modalForm.elements.id) {
              modalForm.elements.id.value = newVariant.id;
              modalForm.elements.id.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          var newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', newVariant.id);
          window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());

          wrapper.setAttribute('data-cl-lens-current-variant-id', String(newVariant.id));

          // <product-rerender> swaps SKU / badges / price / payment-terms /
          // variant-picker / inventory / buy-buttons / pickup-availability /
          // liquid blocks from this fragment.
          form.dispatchEvent(new CustomEvent('product:rerender', {
            detail: { htmlFragment: newContent, productChange: false }
          }));

          // Notify product-gallery and any other variant:change listeners.
          form.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: { formId: form.id, variant: newVariant, previousVariant: null }
          }));

          if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
            window.Shopify.PaymentButton.init();
          }
        });
    }

    select.addEventListener('change', function () {
      Promise.resolve(updateSize()).catch(function (err) {
        if (window.console) console.error('[lens-module] variant update failed', err);
      });
    });

    wrapper.addEventListener('cocoleni-vto:configure', function (event) {
      var request = event.detail || {};
      var names = {142: ['medium', 'm'], 149: ['large', 'l'], 156: ['extra large', 'xl']};
      var accepted = names[request.width];
      var option = accepted && Array.prototype.find.call(select.options, function (value) {
        return accepted.indexOf((value.dataset.optionName || value.textContent).trim().toLowerCase()) !== -1;
      });
      if (!option) { if (request.fail) request.fail(); return; }
      select.value = option.value;
      Promise.resolve(updateSize()).then(function () {
        var current = document.querySelector('[data-cl-lens-section-id="' + sectionId + '"]');
        var trigger = current && current.querySelector('[data-cl-lens-modal-open]');
        if (!trigger) { if (request.fail) request.fail(); return; }
        if (request.ready) request.ready();
        trigger.click();
      }).catch(function () { if (request.fail) request.fail(); });
    });

    // Reverse-sync: keep the lens select in step with anything else that
    // dispatches `variant:change`.
    rerender.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var newName = variant['option' + optionPosition];
      if (!newName) return;
      var match = Array.prototype.find.call(select.options, function (o) {
        return o.dataset.optionName === newName;
      });
      if (match && select.value !== match.value) {
        select.value = match.value;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-cl-lens-actions]').forEach(wireLensModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
